import RedesignDescriptor from './sendSnack-redesign';
import RefiveDescriptor from './sendSnack-refive';
import CanteenDescriptor from './sendSnack-canteen';
import AramarkDescriptor from './sendSnack-aramark';
import CompanyKitchenDescriptor from './sendSnack-companykitchen';
import Settings from 'src/Settings';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
};

export interface SendSnackDescriberData {
  styles: {[index: string]: {[index: string]: number | string}};
  snackDate?: string;
  isSender?: boolean;
  stickerId?: number;
  amount?: number;
  senderName?: string;
  status?: string;
}

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
